module.exports = __webpack_public_path__ + "static/media/aftanverdlaeri_small.029bdc9b.png";